import { flashMessage } from './flash-message';

window.flashMessage = flashMessage;

function initAnnouncementBanner() {
    const banner = document.querySelector('.announcement-banner');

    if (!banner) {
        return;
    }

    window.addEventListener('scroll', () => {
        banner.classList.toggle('scrolled', window.scrollY > 50);
    });
}

function initFormSubmitLinks() {
    document.querySelectorAll('[data-submit-form]').forEach((link) => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            document.getElementById(link.dataset.submitForm)?.submit();
        });
    });
}

function initAutoShownModals() {
    document.querySelectorAll('[data-modal-autoshow]').forEach((modal) => {
        if (window.bootstrap?.Modal) {
            window.bootstrap.Modal.getOrCreateInstance(modal).show();
        }
    });
}

function initLayout() {
    initAnnouncementBanner();
    initFormSubmitLinks();
    initAutoShownModals();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLayout);
} else {
    initLayout();
}
